import { Dispatch, SetStateAction, useState } from 'react';

interface IUsePersistedState {
  <T>(
    key: string,
    defaultValue: T,
    storage?: Storage,
  ): [T, Dispatch<SetStateAction<T>>];
}

const usePersistedState: IUsePersistedState = (
  key,
  defaultValue,
  storage = localStorage,
) => {
  const [state, setState] = useState(() => {
    const persistedState = storage.getItem(key);
    return persistedState ? JSON.parse(persistedState) : defaultValue;
  });

  const setPersistedState = (value: SetStateAction<typeof state>) => {
    const valueToStore = value instanceof Function ? value(state) : value;
    setState(valueToStore);
    storage.setItem(key, JSON.stringify(valueToStore));
  };

  return [state, setPersistedState];
};

export default usePersistedState;
